var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.company.is_freemium == 1)?_c('freemium-locked-alert'):_vm._e(),_c('field',{staticClass:"mb-2",attrs:{"params":{
			type:'btn-group',
			buttons:_vm.reportSections.map(tab => {
				return {text: tab, value: tab}
			}),
			tabStyling:true,
			disableNull:true
		}},model:{value:(_vm.activeSection),callback:function ($$v) {_vm.activeSection=$$v},expression:"activeSection"}}),(_vm.activeSection == 'KPIs')?_c('project-report-widgets',{attrs:{"project":_vm.$store.project}}):(_vm.activeSection == 'Labour Progress')?_c('labour-report'):_vm._e(),_c('accordion',{attrs:{"heading":"Project Timeline"}},[_c('job-timeline',{attrs:{"job":_vm.$store.project,"job-type":"project","weeks-back":"52"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }